import { app } from '../services/feathers'
import { checkFeatureFlag } from '../utils/featureFlag'

// eslint-disable-next-line import/prefer-default-export
export const resetTalent = async (id) => {
  await app
    .service('lambda-talent')
    .create({ action: 'reset-talent', query: { talentId: id } })
}

/**
 * Receives static filters from talent
 * @param {Object} Talent
 * @returns properly formatted object to be sent for atlas-search-offer
 */
export const cleanShould = ({
  location,
  jobDomain,
  subJob,
  sector,
  subSector,
  experience,
  schoolLevel,
  contractTypes,
  remoteWorking,
}) => ({
  location:
    location?.formattedAddress !== null ? location.formattedAddress : undefined,
  subJob: subJob?.length > 0 ? subJob : undefined,
  subSector: subSector?.length > 0 ? subSector : undefined,
  experience: experience?.length > 0 ? experience : undefined,
  schoolLevel: schoolLevel?.length > 0 ? schoolLevel : undefined,
  contractType: contractTypes?.length > 0 ? contractTypes : undefined,
  jobDomain: jobDomain?.length > 0 ? jobDomain : undefined,
  sector: sector?.length > 0 ? sector : undefined,
  remoteWorking: remoteWorking?.length > 0 ? remoteWorking : undefined,
})

export const cleanStaticFilter = ({ jobDomain, sector, contractTypes }) => ({
  contractType: contractTypes?.length > 0 ? contractTypes : undefined,
  jobDomain: jobDomain?.length > 0 ? jobDomain : undefined,
  sector: sector?.length > 0 ? sector : undefined,
})

export const handleInitStatus = async (candidateIds, status) => {
  await app.service('lambda-talent').create({
    action: 'change-init-status',
    query: {
      ids: candidateIds.map((el) => el.candidateId),
      status,
      domainJ2BD: checkFeatureFlag ? true : undefined,
    },
  })
}
